import { useCallback, useState } from "react";

export const useModal = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalItemId, setModalItemId] = useState(0);

  const onShowModal = useCallback(() => {
    setIsModalOpen(true);
  }, []);

  const onHideModal = useCallback(() => {
    setIsModalOpen(false);
    setModalItemId(0);
  }, []);

  const onModifyShowModal = useCallback(
    (id: number) => {
      onShowModal();
      setModalItemId(id);
    },
    [onShowModal],
  );

  return {
    isModalOpen,
    modalItemId,
    onShowModal,
    onHideModal,
    onModifyShowModal,
  };
};
